import QuestionValueAngle from "../QuestionValueAngle";
import QuestionModule from "./QuestionModule";
import QuestionValueBooleanShape from "../QuestionValueBooleanShape";
import QuestionModel from "../QuestionModel";
import QuestionValue from "../QuestionValue";
import QuestionValueMeasurementLabel from "../QuestionValueMeasurementLabel";
import QuestionValueTexture from "../QuestionValueTexture";
import QuestionValueBoolean from "../QuestionValueBoolean";

export default class QuestionModuleShapes extends QuestionModule {
	constructor() {
		super();
	}

	create(data) {
		const question = super.create(data);

        //blanket ban on numbers to words conversion for this module
		question.useWords = false;

		switch (data.type)
		{
			case QuestionModel.TYPE_SHAPE_SYMMETRY:
			case QuestionModel.TYPE_SHAPE_VISUAL_ISOSCELES:
			case QuestionModel.TYPE_SHAPE_PERPENDICULAR_LINES:
			case QuestionModel.TYPE_SHAPE_PARALLEL_LINES:
			case QuestionModel.TYPE_SHAPE_SIDES_UNDER_FOUR:
			case QuestionModel.TYPE_SHAPE_SIDES_EQUAL_FOUR:
			case QuestionModel.TYPE_SHAPE_VISUAL_RIGHT_ANGLE:
				{
					this._selectShapes(data, question);
					break;
				}
			case QuestionModel.TYPE_SHAPE_ODD_ONE_OUT:
				{
					this._oddOneOut(data, question);
					break;
				}
			case QuestionModel.TYPE_MISSING_ANGLE:
				{
					this._missingAngle(data, question);
					break;
				}
			case QuestionModel.TYPE_FIXED_TRIANGLE:
				{
					this._fixedTriangle(data, question);
					break;
				}
			case QuestionModel.TYPE_VOLUME:
				{
					this._volume(data, question);
					break;
				}
			case QuestionModel.TYPE_SHAPE_ANGLE_TYPE:
				{
					this._angleType(data, question);
					break;
				}
			case QuestionModel.TYPE_SHAPE_SYMMETRY_LINES:
				{
					this._symmetryLines(data, question);
					break;
				}
			case QuestionModel.TYPE_SHAPE_VERTICES:
				{
					this._vertices(data, question);
					break;
				}
			case QuestionModel.TYPE_SHAPE_ROTATED_SHAPE:
				{
					this._rotatedShape(data, question);
					break;
				}
			case QuestionModel.TYPE_DIAMETER:
				{
					this._diameter(data, question);
					break;
				}
			case QuestionModel.TYPE_FACES:
				{
					this._faces(data, question);
					break;
				}
		}
		question.xp = data.xp;

		return question;
	}

	_oddOneOut(data, question){
		/*
		let newData = P3.utils.copyObject(data, true);
		let totalCorrect = 1;

		const correctClone = newData.correct.slice();
		//console.log(correctClone);

		for (let i = 0; i < totalCorrect; i++) {
			let selected = P3.utils.selectRandom(correctClone);
			correctClone.splice(correctClone.indexOf(selected), 1);
			question.values.push(new QuestionValueBooleanShape(1, selected.image));
		}

		question.part = [];
		question.options = [];
		question.totalCorrect = totalCorrect;

		for (let i = 0; i < totalCorrect; i++) question.part.push(i);

		for (let i = 0; i < question.values.length; i++) question.options.push(question.values[i]);

		const optionsClone = newData.shapes.slice();
		while(question.options.length < Math.min(4, question.options.length + newData.shapes.length)){
			let selected = P3.utils.selectRandom(optionsClone);
			optionsClone.splice(optionsClone.indexOf(selected), 1);
			question.options.push(new QuestionValueBooleanShape(0, selected.image));
		}
		P3.utils.shuffleArray(question.options);
		*/

		const answer = P3.utils.selectRandom(data.correct);
		question.values.push(new QuestionValueBooleanShape(1, answer.image));
		question.options = [question.values[0]];
		question.part = [0];

		const shapes = data.shapes.slice();
		while (question.options.length < Math.min(4, question.options.length + data.shapes.length))
		{
			const selected = P3.utils.selectRandom(shapes);
			shapes.splice(shapes.indexOf(selected), 1);
			question.options.push(new QuestionValueBooleanShape(0, selected.image));
		}

		P3.utils.shuffleArray(question.options);
	}

	_selectShapes(data, question){
		let newData = P3.utils.copyObject(data, true);
		let totalCorrect = P3.math.randomInt(1, Math.min(3, newData.correct.length));

		const correctClone = newData.correct.slice();
		//console.log(correctClone);

		for (let i = 0; i < totalCorrect; i++) {
			let selected = P3.utils.selectRandom(correctClone);
            correctClone.splice(correctClone.indexOf(selected), 1);
            let t = new QuestionValueBooleanShape(1, selected.image);
            selected.hasOwnProperty('rotation') && (t.rotation = selected.rotation);
			question.values.push(t);
		}

		question.part = [];
		question.options = [];
		question.totalCorrect = totalCorrect;

		for (let i = 0; i < totalCorrect; i++) question.part.push(i);

		for (let i = 0; i < question.values.length; i++) question.options.push(question.values[i]);

		const optionsClone = newData.shapes.slice();
		while(question.options.length < Math.min(5, question.options.length + newData.shapes.length)){
			let selected = P3.utils.selectRandom(optionsClone);
			optionsClone.splice(optionsClone.indexOf(selected), 1);
			question.options.push(new QuestionValueBooleanShape(0, selected.image));
		}
		P3.utils.shuffleArray(question.options);
	}

	_missingAngle(data, question){
		let round = (value, decimals)=> {
            return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
            //return parseFloat(value.toFixed(decimals));
		};

		let selected = P3.utils.selectRandom(data.variations);
		let maxAngle = selected.max_angle;
		let values = selected.values;

		question.values = [];
		let answer = maxAngle;
		let range = selected.range;

		if(values === 2){
			let val = data.difficulty === 1 ? P3.math.randomInt(range.min, range.max) : P3.math.random(range.min, range.max);
			val = parseFloat(round(val, 1));
			question.values.push(new QuestionValueMeasurementLabel(answer - val, P3.assets.texture(selected.texture), selected.labels[0]));
			question.values.push(new QuestionValueMeasurementLabel(val, P3.assets.texture(selected.texture), selected.labels[0]))
		} else if(values === 3 && data.difficulty !== 3){
			let val = data.difficulty === 1 ? P3.math.randomInt(range.min, range.max) : P3.math.random(range.min, range.max);
			val = parseFloat(round(val, 1));
			question.values.push(new QuestionValueMeasurementLabel(val, P3.assets.texture(selected.texture), selected.labels[0]));
			question.values.push(new QuestionValueMeasurementLabel(val, P3.assets.texture(selected.texture), selected.labels[1]));
			question.values.push(new QuestionValueMeasurementLabel(answer - (val * 2), P3.assets.texture(selected.texture), selected.labels[0]));
		}else{
			let answer = P3.math.randomInt(range.min, range.max);
			let val = 180 - answer - (P3.math.randomInt(5, 180 - answer - 10));
			val = parseFloat(round(val, 1));
			let val2 = 180 - answer - val;
			val2 = parseFloat(round(val2, 1));
			question.values.push(new QuestionValueMeasurementLabel(val, P3.assets.texture(selected.texture), selected.labels[0]));
			question.values.push(new QuestionValueMeasurementLabel(val2, P3.assets.texture(selected.texture), selected.labels[1]));
			question.values.push(new QuestionValueMeasurementLabel(answer, P3.assets.texture(selected.texture), selected.labels[0]));
		}

		question.difficulty = data.difficulty;
		question.part = values - 1;

		let precision = (a)=> {
			if (!isFinite(a)) return 0;
			var e = 1, p = 0;
			while (Math.round(a * e) / e !== a) { e *= 10; p++; }
			return p;
		};

		let options = [question.answer];
		let answerPrecision = precision(question.answer.value);
		let k = 1000;
		while (options.length < 5 && k-- > 0) {
			const value = (() => {
				const min = -20;
				const max = 20;
				if(data.difficulty === 1)
					return Math.abs(Math.round(question.answer.value + P3.math.randomInt(min, max)));
				else
					return Math.abs(round(question.answer.value + P3.math.random(min, max), answerPrecision));
			})();
            options.every(x => x.value !== value) && options.push(new QuestionValueAngle(value, data.units.short));
			//options.every(x => x.value !== value) && options.push(new QuestionValueMeasurementLabel(value, P3.assets.texture(selected.texture), data.units.short));
		}

		//quick fix save editing some else code and breaking things, going to remove answer from front, and add answer back in to options as correct value type
        options.splice(0,1);

        options.push(new QuestionValueAngle(question.answer.value, data.units.short));

		P3.utils.shuffleArray(options);
		question.options = options;
		question.notations = [];
		question.unit = data.units;

		//console.log(question);
	}

	_fixedTriangle(data, question){
		let selected = P3.utils.selectRandom(data.options);

		question.temp = new QuestionValue(selected.question);

		for (let i = 0; i < selected.correct.length; i++) {
			question.values.push(new QuestionValue(selected.correct[i]));
		}

		let options = ["Isosceles", "Scalene", "Equilateral"];

		for (let i = 0; i < options.length; i++) {
			question.options.push(new QuestionValue(options[i]));
		}

		P3.utils.shuffleArray(question.options);
		question.part = selected.part;
	}

	_volume(data, question){
		let val = P3.math.randomInt(data.range.min, data.range.max);
		question.values.push(new QuestionValue(val));
		question.values.push(new QuestionValue(Math.pow(val, 3)));
		question.part = 1;
		let options = [question.answer];
		let k = 1000;
		while (options.length < 5 && k-- > 0) {
			const value = (() => {
				const min = -5;
				const max = 5;
				return Math.abs(Math.round(question.answer.value + P3.math.randomInt(min, max)));
			})();
			options.every(x => x.value !== value) && options.push(new QuestionValue(value));
		}
		P3.utils.shuffleArray(options);
		question.options = options;
	}

	_angleType(data, question){
		let tempData = data.options.slice();
		let answer = P3.utils.selectRandom(tempData);

		question.useBG = true;
		question.part = 0;
		question.values = [new QuestionValueTexture(answer.type, answer.type, P3.assets.texture(answer.texture))];
		question.options = [question.answer];
		tempData.splice(tempData.indexOf(answer), 1);

		for (let i = 0; i < tempData.length; i++) {
			question.options.push(new QuestionValueTexture(tempData[i].type, tempData[i].type, P3.assets.texture(tempData[i].texture)))
		}

		P3.utils.shuffleArray(question.options);
	}

	_symmetryLines(data, question){
		let tempData = data.options.slice();
		let answer = P3.utils.selectRandom(tempData);

		question.part = 0;
		question.values = [new QuestionValueTexture(answer.value, answer.value, P3.assets.texture(answer.texture))];
		question.options = [question.answer];

		let k = 1000;
		while (question.options.length < 5 && k-- > 0) {
			const value = (() => {
				const min = 1;
				const max = 12;
				return Math.abs(Math.round(P3.math.randomInt(min, max)));
			})();
			question.options.every(x => x.value !== value) && question.options.push(new QuestionValue(value));
		}

		P3.utils.shuffleArray(question.options);
	}

	_vertices(data, question){
		let tempData = data.options.slice();
		let answer = P3.utils.selectRandom(tempData);

		question.part = 0;
		question.shape = answer.name;
		question.values = [new QuestionValueBoolean(answer.verts > answer.faces ? 1 : 0)];
		question.options = [question.answer, new QuestionValueBoolean(!question.answer.value)];
		P3.utils.shuffleArray(question.options);
		console.log(question.answer);
	}

	_rotatedShape(data, question){
		let selected = P3.utils.selectRandom(data.options);
		question.values.push(new QuestionValueTexture(selected, selected, P3.utils.selectRandom(data.shapes)));
		question.part = 0;

		question.options = [question.answer];
		let k = 1000;
		while (question.options.length < 4 && k-- > 0) {
			const value = (() => {
				const min = Math.max(0, question.answer.value -50);
				const max = Math.min(354, question.answer.value + 50);
				return Math.ceil(P3.math.randomInt(min, max) / 5) * 5;
			})();
			question.options.every(x => x.value !== value) && question.options.push(new QuestionValue(value));
		}
		P3.utils.shuffleArray(question.options);
	}

	_diameter(data, question){
		let unit = P3.utils.selectRandom(data.units);
		let randomData = P3.utils.selectRandom(P3.utils.objectToArray(data.range));
		question.values = this._generateMeasurementLabel(randomData, unit);
		question.part = data.parts;

		let r;
		r = question.values[0].value * 2;

		question.values.push(new QuestionValueMeasurementLabel(parseFloat(r.toFixed(1)), P3.assets.texture(randomData.texture), ''));
		question.options = this.generateOptions(question, 5);
		question.notations = randomData.notations;
		question.unit = unit;
	}

	_faces(data,question){
		let generateOptions = (question, count)=> {
			const range = P3.utils.objectToArray(question.range);
			const options = [new QuestionValue(question.values[0].value)]

			let k = 200;
			while (options.length < count && --k > 0) {
				const t = P3.utils.selectRandom(range);
				if (options.every(x => x.value !== t.value)) {
					options.push(new QuestionValue(t.value));
				}
			}
			P3.utils.shuffleArray(options);
			return options;
		};

		const range = P3.utils.objectToArray(data.range);
		const answer = P3.utils.selectRandom(range);
		question.values = [new QuestionValueTexture(answer.value, answer.name, P3.assets.texture(answer.image))];
		question.options = generateOptions(question, data.values, range);
		//question.options[0] = new QuestionValue(answer.value);
		question.hack = true;
		console.log(answer.value);
	}

	_generateMeasurementLabel(data, unit){
		let labels = [];
		for (let i = 0; i < data.labels.length; ++i) {
			let label = data.labels[i];
			const n = P3.math.randomInt(label.range.min, label.range.max);
			labels.push(new QuestionValueMeasurementLabel(n, '', label.value, unit.short));
		}
		return labels;
	}

	generateOptions(question, count = 5) {
		let k = 1000;
		let options = [question.answer];

		let precision = (a)=> {
			if (!isFinite(a)) return 0;
			var e = 1, p = 0;
			while (Math.round(a * e) / e !== a) { e *= 10; p++; }
			return p;
		};

		let round = (value, decimals)=> {
			return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
		};

		let answerPrecision = precision(question.answer.value);

		while (options.length < count && k-- > 0) {
			const value = (() => {
				const min = Math.min(-10, -question.answer.value);
				const max = Math.max(10, question.answer.value);
				return Math.abs(round(question.answer.value + P3.math.random(min, max), answerPrecision));
			})();
			options.every(x => x.value !== value) && options.push(new QuestionValue(value));
		}
		P3.utils.shuffleArray(options);
		return options;
	}
}